import { useMutate } from 'restful-react'
import { SendConfirmationCodeBody } from './interfaces'

const useSendConfirmationCode = () => {
    return useMutate<any, any, any, SendConfirmationCodeBody>('POST', '/user/lgpdconfirmationcode')
}

export default useSendConfirmationCode
